import PropTypes from 'prop-types';
import React from 'react';
import ModalActionCreator from 'action_creators/modal';
import ModalContent from 'views/plugins/tours/page/contact_guide/modal_content';
import { numberOrString } from 'lib/prop_types';
import { t } from 'services/translation';

export default class extends React.PureComponent {
  static displayName = 'TourPage-BookingDetails-NoAvailability';

  static propTypes = {
    guide_id: numberOrString.isRequired,
    tour_id: numberOrString.isRequired,
    guide_name: PropTypes.string.isRequired,
    tour_name: PropTypes.string.isRequired,
    is_company: PropTypes.bool,
    sold_out_link_text: PropTypes.string,
    sold_out_link: PropTypes.string,
  };

  static defaultProps = {
    is_company: false,
  };

  _linkClicked = (e) => {
    if (this.props.sold_out_link) {
      return;
    }

    e.preventDefault();
    ModalActionCreator.show({
      content: this._contactModal(),
    });
  };

  _contactProps = () => {
    return {
      guideId: this.props.guide_id,
      tourId: this.props.tour_id,
      guideName: this.props.guide_name,
      tourName: this.props.tour_name,
      isCompany: this.props.is_company,
    };
  };

  _contactModal = () => {
    return <ModalContent {...this._contactProps()} />;
  };

  _soldOutLinkText = () => {
    if (this.props.sold_out_link_text) {
      return this.props.sold_out_link_text;
    }

    return t('CONTACT_US_FOR_FUTURE_AVAILABILITY');
  };

  _soldOutLink = () => {
    if (this.props.sold_out_link) {
      return this.props.sold_out_link;
    } else {
      return '#';
    }
  };

  render() {
    return (
      <div className="TourPage-BookingDetails-NoAvailability">
        <div className="text">{t('SORRY_WERE_COMPLETELY_BOOKED')}</div>
        <div className="link">
          <a
            href={this._soldOutLink()}
            onClick={this._linkClicked}
            target="_blank"
            className="brand-color"
          >
            {this._soldOutLinkText()}
          </a>
        </div>
      </div>
    );
  }
}
